export enum CompanyDetailTabs {
    Dashboard = 'Dashboard',
    Details = 'Details',
    AdditionalInfo = 'AdditionalInfo',
    RelatedContacts = 'RelatedContacts',
    ActionLog = 'ActionLog',
    Contract = 'Contract',
    Payments = 'Payments',
    Billing = 'Billing',
}

export enum CompanyDetailForms {
    ContactForm = 'ContactForm',
    AdditionalInfoForm = 'AdditionalInfoForm',
    NotesForm = 'NotesForm',
    ContractForm = 'ContractForm',
    CreditLimitsForm = 'CreditLimitsForm',
}
